import { createSlice } from "@reduxjs/toolkit";

const initialState = {};

export const participantsDetailsSlice = createSlice({
  name: "participantsDetails",
  initialState,
  reducers: {
    updateParticipantsDetails: (state, action) => {
      return { ...state, ...action.payload };
    },
    resetParticipantsDetails: () => initialState,
    resetSenderParticipantDetails: (state) => {
      const finalState = { ...state };

      for (let key in finalState) {
        if (key?.includes("sender")) {
          delete finalState[key];
        }
      }

      return finalState;
    },
    resetRecipientParticipantDetails: (state) => {
      const finalState = { ...state };

      for (let key in finalState) {
        if (key?.includes("recipient")) {
          delete finalState[key];
        }
      }

      return finalState;
    },
  },
});

export const {
  updateParticipantsDetails,
  resetParticipantsDetails,
  resetSenderParticipantDetails,
  resetRecipientParticipantDetails,
} = participantsDetailsSlice.actions;

export const participantsDetails = (state) => state.participantsDetails;
export default participantsDetailsSlice.reducer;
